import { render, staticRenderFns } from "./CaseItem.vue?vue&type=template&id=7d851870&scoped=true"
import script from "./CaseItem.vue?vue&type=script&lang=ts"
export * from "./CaseItem.vue?vue&type=script&lang=ts"
import style0 from "./CaseItem.vue?vue&type=style&index=0&id=7d851870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d851870",
  null
  
)

export default component.exports